import { remainingCapacity as calcRemainingCapacity } from '../../../utils/box-capacity';
export const computeCapacity = (selectedItems, selectableUnits, boxCapacity)=>{
    const selectedSpace = selectedItems.reduce((sum, k)=>{
        const u = selectableUnits.find((x)=>x.unitKey === k);
        var _u_effectiveSpace;
        return sum + ((_u_effectiveSpace = u === null || u === void 0 ? void 0 : u.effectiveSpace) !== null && _u_effectiveSpace !== void 0 ? _u_effectiveSpace : 0);
    }, 0);
    const remainingCapacity = calcRemainingCapacity(selectedItems, selectableUnits, boxCapacity);
    const remainingCapacityPresentation = typeof remainingCapacity === 'number' && Number.isFinite(remainingCapacity) ? String(remainingCapacity) : '—';
    let usedPct = 0;
    if (boxCapacity != null) {
        usedPct = boxCapacity > 0 ? Math.max(0, Math.min(100, Math.round(selectedSpace / boxCapacity * 100))) : selectedSpace > 0 ? 100 : 0;
    }
    return {
        remainingCapacity,
        usedPct,
        remainingCapacityPresentation
    };
};
